/*
 *
 * LanguageProvider
 *
 * this component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `config/locales/{lang}/{files}.yml`
 * convert to json in `config/react/locales/{lang}/{lang}.json`)
 */

import React from "react";
import PropTypes from "prop-types";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { flattenMessages } from "../../../js/utils/functions";

const LanguageProvider = ({ locale, messages, children }) => {
  return (
    <IntlProvider
      locale={locale}
      key={locale}
      messages={flattenMessages(messages[locale])}
      textComponent={React.Fragment}
    >
      {React.Children.only(children)}
    </IntlProvider>
  );
};

export default connect((state) => ({
  localeDefault: state.language.locale,
}))(LanguageProvider);

LanguageProvider.propTypes = {
  locale: PropTypes.string.isRequired,
  messages: PropTypes.shape(),
  children: PropTypes.element.isRequired,
};
